import {Action} from '@ngrx/store';
import {DragStartPayload} from '../models/drag-and-drop';

export enum DragActionTypes {
  DragStart = '[Drag] Drag Start',
  DragEnd = '[Drag] Drag End'
}

export class DragStart implements Action {
  readonly type = DragActionTypes.DragStart;

  constructor(public payload: DragStartPayload) {
  }
}

export class DragEnd implements Action {
  readonly type = DragActionTypes.DragEnd;
}

export type DragActions =
  | DragStart
  | DragEnd;
